import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getFeeRecommendationHeading } from 'utils/feeRecommendations';

import { titleStyles } from './FeeRecommendationTitle.styles';

const FeeRecommendationTitle = ({ item }) => {
  const { title, subtitle } = getFeeRecommendationHeading(item);

  return (
    <Box sx={titleStyles}>
      <Typography variant="medium14">{title}</Typography>
      {!!subtitle && (
        <Typography color="text.secondary" variant="regular12">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

FeeRecommendationTitle.propTypes = {
  item: PropTypes.object.isRequired,
};

export default memo(FeeRecommendationTitle);
